import React, { useEffect, useState } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Select from "react-select";
import dayjs from "dayjs";
import api from "../../API/axiosInstance";
import makeAnimated from "react-select/animated";
import { MyContext } from "../../MyContextApi";
import { useNavigate } from "react-router-dom";
import ReportDateTimeRange from "./ReportDateTimeRange";
import {
  platforms,
  sections,
  languages,
  sentiments,
  intensity,
  apidata,
  content,
  range,
} from "../Filters/FilterData";

import { generateHash } from "../../API/hashUtil";
import Box from "@mui/material/Box";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import FilterListIcon from "@mui/icons-material/FilterList"; // Import filter icon
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { downloadCSV, downloadSimpleCSV, downloadSimpleExcel } from "./CSV";
import { handleSentimentSummary } from "../../API/SentimentSummary";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import "./../../styles/SpeedDial.css";
import { useAuth } from "../../context/AuthContext";



import { downloadReportPdf } from "./Reportpdfdownload"


export default function SwipeableTemporaryDrawer() {
  const navigate = useNavigate();
  let stringParams = "";
  const token = localStorage.getItem("Token");
  const [isHovered, setIsHovered] = useState(false);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [clearParams, setclearParams] = useState(false);
  const [anchor, setAnchor] = useState("right");
  const [open, setOpen] = useState(false);
  const [clearDates, setClearDates] = useState(false);


const { user } = useAuth();

const userName = user?.username || "";

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen); // Toggle the open state
  };

  const {
    // availablePlatforms,
    // setAvailablePlatforms,
    analyticsData,
    serverresponse,
    apiSelect,
    setAPISelect,
    selectedPlatforms,
    setSelectedPlatforms,
    selectedSections,
    setSelectedSections,
    selectedLanguages,
    setSelectedLanguages,
    selectedSentiment,
    setSelectedSentiment,
    selectedIntensity,
    setSelectedIntensity,
    setpdfToSimple,
    setpdfFromSimple,
    toggleButton,
    setIsOpen,
    setFromDateTime,
    setToDateTime,
    settoggleButton,
    setResponseCount,
    setServerResponse,
    navigationCount,
    loading,
    setLoading,
    setNewsCount,
    NewsCount,
    applyValue,
    setApplyValue,
    selectedRange,
    setSelectedRange,
    selectedContent,
    setSelectedContent,
    selectedKeyword,
    setSelectedKeyword,
    reporttoDateTimeFormatted,
    setreportToDateTimeFormatted,
    reportfromDateTimeFormatted,
    setreportFromDateTimeFormatted,
    sentimentSummary,
    setsentimentSummary,
  } = React.useContext(MyContext);


  const [keywordOptions, setKeywordOptions] = useState([]);
  const [reportfromDateTime, setreportFromDateTime] = useState(null);
  const [reporttoDateTime, setreportToDateTime] = useState(null);
  const toggleDrawer = (open) => {
    setState({ ...state, [anchor]: open }); // Use the anchor to toggle its state
  };
  const handleFromDateTimeChange = (fromDateTime) => {
    const formattedFromDateTime = dayjs(fromDateTime).format(
      "YYYY-MM-DDTHH:mm:ss[Z]"
    );
    const simpleFromDateTimes = dayjs(fromDateTime).format("DD-MM-YYYY");
    setpdfFromSimple(simpleFromDateTimes);
    setreportFromDateTimeFormatted(formattedFromDateTime);
  };

  const handleToDateTimeChange = (toDateTime) => {
    const formattedToDateTime = dayjs(toDateTime).format(
      "YYYY-MM-DDTHH:mm:ss[Z]"
    );
    const simpleToDateTimes = dayjs(toDateTime).format("DD-MM-YYYY");
    setpdfToSimple(simpleToDateTimes);
    setreportToDateTimeFormatted(formattedToDateTime);
  };

  const handlePlatformChange = (selectedOptions) => {
    //
    setSelectedPlatforms(selectedOptions);
  };
  const handleKeywordChange = (selectedOptions) => {
    //
    setSelectedKeyword(selectedOptions);
  };
  const handleSectionChange = (selectedOptions) => {
    //
    setSelectedSections(selectedOptions);
  };

  const handleLanguageChange = (selectedOptions) => {
    setSelectedLanguages(selectedOptions);
  };

  const handleSentimentChange = (selectedOptions) => {
    setSelectedSentiment(selectedOptions);
  };

  const handleIntensity = (selectedOptions) => {
    setSelectedIntensity(selectedOptions);
  };

  const handleContent = (selectedOptions) => {
    setSelectedContent(selectedOptions);
  };

  const handleRange = (selectedOptions) => {
    setSelectedRange(selectedOptions);
  };

  const handleApiData = (selectedOptions) => {
    //
    setAPISelect(selectedOptions);
  };

  const Platforms = makeAnimated(platforms);
  const Sentiments = makeAnimated(sentiments);
  const Languages = makeAnimated(languages);
  const Sections = makeAnimated(sections);
  const Intensity = makeAnimated(intensity);
  const ApiData = makeAnimated(apidata);
  const Content = makeAnimated(content);
  const handleChannelCount = async () => {
    let stringParams = {
      startDateStr: reportfromDateTimeFormatted
        ? reportfromDateTimeFormatted.toString()
        : "",
      endDateStr: reporttoDateTimeFormatted
        ? reporttoDateTimeFormatted.toString()
        : "",
    };

    const hexHash = generateHash(stringParams);

    //

    await api
      .get(`/api/channelCount`, {
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

          // Standard Headers
          "Content-Type": "application/json",
        },
        params: {
          startDateStr: reportfromDateTimeFormatted,
          endDateStr: reporttoDateTimeFormatted,
          HPPcode: hexHash,
        },
      })
      .then((res) => setNewsCount(res.data))
      .catch((err) => console.error("Error fetching report details:", err));
  };





  //

  const sendDataToServer = () => {
    handleFilterReset();
    fetchKeywords();
    if (apiSelect?.value === "news/report") {
      handleChannelCount();
    }

    const sectionValues = selectedSections.map((section) => section?.value);
    const sectionParams = sectionValues.join(",");
    const sectionHex = sectionValues.join("");
    // Should print true
    // Debugging: Check what the actual value is

    const platformValues = selectedPlatforms.map((platform) => platform?.value);
    const platformParams = platformValues.join(",");
    const platformHex = platformValues.join("");

    // Normalize the selectedKeyword to always be an array
    const keywordsArray = Array.isArray(selectedKeyword)
      ? selectedKeyword
      : selectedKeyword
        ? [selectedKeyword]
        : [];

    // Now it's safe to map over keywordsArray
    const keywordValues = keywordsArray.map((keyword) => keyword?.value);
    const keywordParams = keywordValues.join(",");
    const keywordHex = keywordValues.join("");

    const languageValues = selectedLanguages.map((language) => language?.value);
    const languageParams = languageValues.join(",");
    const languageHex = languageValues.join("");

    const sentimentValues = selectedSentiment.map(
      (sentiment) => sentiment?.value
    );
    const sentimentParams = sentimentValues.join(",");
    const sentimentHex = sentimentValues.join("");

    const intensityValues =
      selectedIntensity &&
      selectedIntensity.map((intensity) => intensity?.value);
    const intensityParams = intensityValues && intensityValues.join(",");
    const intensityHex = intensityValues && intensityValues.join("");

    const contentValues = selectedContent.map((content) => content?.value);
    const contentParams = contentValues.join(",");
    const contentHex = contentValues.join("");

    const platformsParam = platformParams.length > 0 ? platformParams : null;

    const keywordParam = keywordParams.length > 0 ? keywordParams : null;

    const sectionsParam = sectionParams.length > 0 ? sectionParams : null;
    const languagesParam = languageParams.length > 0 ? languageParams : null;
    const sentimentsParam = sentimentParams.length > 0 ? sentimentParams : null;
    const intensityParam =
      intensityParams && intensityParams.length > 0 ? intensityParams : null;
    const contentParam =
      contentParams && contentParams.length > 0 ? contentParams : null;

    //STRING PARAMS FOR ENCODED HASH START
    const stringParams = {
      startDateStr: reportfromDateTimeFormatted
        ? reportfromDateTimeFormatted.toString()
        : "",
      endDateStr: reporttoDateTimeFormatted
        ? reporttoDateTimeFormatted.toString()
        : "",
      ...(apiSelect.value === "api/socialSentiments" && {
        platforms: platformHex ? platformHex.toString() : "",
        sentiments: sentimentHex ? sentimentHex.toString() : "",
      }),
      ...(apiSelect.value === "api/filter" && {
        platforms: platformHex ? platformHex.toString() : "",
        sections: sectionHex ? sectionHex.toString() : "",
        languages: languageHex ? languageHex.toString() : "",
        sentiments: sentimentHex ? sentimentHex.toString() : "",
        intensity: intensityHex ? intensityHex.toString() : "",
        ctype: contentHex ? contentHex.toString() : "",
        searchKeyword: keywordHex ? keywordHex.toString() : "",
      }),
    };

    const hexHash = generateHash(stringParams);
    //
    //
    //STRING PARAMS FOR ENCODED HASH END

    const params =
      clearParams && clearParams
        ? {
          startDateStr: reportfromDateTimeFormatted,
          endDateStr: reporttoDateTimeFormatted,
          HPPcode: hexHash,
        }
        : {
          // page: navigationCount,
          platforms: platformsParam,
          sections: sectionsParam,
          sentiments: sentimentsParam,
          languages: languagesParam,
          startDateStr: reportfromDateTimeFormatted,
          endDateStr: reporttoDateTimeFormatted,
          // startDateStr: "2024-11-30T18:30:00.000Z",
          // endDateStr: "2024-12-10T18:29:59.999Z",
          intensity: intensityParam,
          ctype: contentParam,
          searchKeyword: keywordParam,
          HPPcode: hexHash,
        };

    setLoading(true);
    setApplyValue(apiSelect.value);
    //

    api
      .get(
        `/${apiSelect?.value === "api/filter"
          ? "api/filter"
          : apiSelect?.value === "news/report"
            ? "news/report"
            : apiSelect?.value === "fakenews/printFakeNews"
              ? "fakenews/printFakeNews"
              : apiSelect?.value === "api/socialSentiments"
                ? "api/socialSentiments"
                : "analysis/imageData"
        }`,
        {
          params,
          headers: {
            // Security Headers
            "X-XSS-Protection": "1; mode=block",
            Authorization: `Bearer ${token}`,
            "X-Content-Type-Options": "nosniff",
            "X-Frame-Options": "DENY",
            "Referrer-Policy": "strict-origin-when-cross-origin",
            "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

            // Standard Headers
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setServerResponse(response.data);
        setResponseCount(response.data.length);

        const sessionIds = response.data
          .map((item) => item.sessionId)
          .filter((sessionId) => sessionId);

        // Call handleSentimentSummary with sessionIds if API is socialSentiments
        if (
          apiSelect?.value === "api/socialSentiments" &&
          sessionIds.length > 0
        ) {
          handleSentimentSummary(sessionIds, token)
            .then((data) => {
              setsentimentSummary(data); // use it where you need
            })
            .catch((err) => {
              console.error("Failed to get sentiment summary", err);
            });
        }
        setLoading(false); // Set loading state to false
      })
      .catch((error) => {
        console.error("Error sending data to server:", error);
        setLoading(false); // Set loading state to false
      });

    setclearParams(false);
  };

  const fetchKeywords = async () => {
    stringParams = {
      startDateStr: reportfromDateTimeFormatted
        ? reportfromDateTimeFormatted.toString()
        : "",
      endDateStr: reporttoDateTimeFormatted
        ? reporttoDateTimeFormatted.toString()
        : "",
    };
    const hexHash = generateHash(stringParams);
    const params = {
      startDateStr: reportfromDateTimeFormatted,
      endDateStr: reporttoDateTimeFormatted,
      HPPcode: hexHash,
    };
    try {
      const response = await api.get(`/api/keywordslist`, {
        params,
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          Authorization: `Bearer ${token}`,
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",

          // Standard Headers
          "Content-Type": "application/json",
        },
      });
      const formattedOptions = response.data.map((keyword) => ({
        label: keyword,
        value: keyword, // Both label and value are the same
      }));
      setKeywordOptions(formattedOptions);
    } catch (error) {
      console.error("Error fetching keywords:", error);
    }
    setclearParams(false);
  };

  const handleClear = () => {
    setclearParams(true);
    setSelectedPlatforms([]);
    setSelectedSections([]);
    setSelectedLanguages([]);
    setSelectedSentiment([]);
    setSelectedKeyword([]);
    setSelectedIntensity(null);
    setreportFromDateTimeFormatted(null);
    setreportToDateTimeFormatted(null);
    setAPISelect({ value: "api/filter", label: "Social Media Report" });
    setServerResponse(null);
    setResponseCount(0);
    setToDateTime(null);
    setFromDateTime(null);
    setSelectedContent([]);
    setpdfFromSimple(null);
    setreportFromDateTimeFormatted(null);
    setpdfToSimple(null);
    setreportToDateTimeFormatted(null);
    setreportToDateTime(null);
    setreportFromDateTime(null);
    // if (clearParams === true) {
    //   sendDataToServer();
    // }
  };

  const handleFilterReset = () => {
    if (
      apiSelect.value !== "api/filter" &&
      apiSelect.value !== "api/socialSentiments"
    ) {
      setclearParams(true);
      setSelectedPlatforms([]);
      setSelectedSections([]);
      setSelectedLanguages([]);
      setSelectedSentiment([]);
      setSelectedIntensity(null);
      setSelectedKeyword([]);
      setSelectedContent([]);
      if (clearParams === true) {
        sendDataToServer();
      }
    }
  };

  const filteredPlatforms = platforms.map((option) => ({
    ...option,
    // isDisabled: !availablePlatforms.includes(option.value),
  }));

  const handleFilterButtonClick = () => {
    toggleDrawer(true); // This will open the drawer
    //
  };
  const handleApply = () => {
    sendDataToServer();
    // toggleDrawer(false);
  };



  const handlePrintButtonClick = () => {

    downloadReportPdf({
      apiSelect,
      reportfromDateTimeFormatted,
      reporttoDateTimeFormatted,
      selectedPlatforms,
      selectedSections,
      selectedLanguages,
      selectedSentiment,
      selectedIntensity,
      selectedContent,
      selectedKeyword,
      fileType : "pdf",
      onStart: () => setLoading(true),
      onSuccess: () => {
        setLoading(false);
        const reportPlatforms = serverresponse
          ? [...new Set(serverresponse.map((r) => r.platform))]
          : selectedPlatforms.map((p) => p?.value);

        const now = new Date();
        const formattedDateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}T${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}.000+00:00`;

        api
          .post(
            `/user/saveDetails`,
            {
              platform: reportPlatforms,
              startDate: reportfromDateTimeFormatted,
              endDate: reporttoDateTimeFormatted,
              reportType: apiSelect.label,
              date: formattedDateTime,
              username: userName,
            },
            {
              headers: {
                "X-XSS-Protection": "1; mode=block",
                Authorization: `Bearer ${token}`,
                "X-Content-Type-Options": "nosniff",
                "X-Frame-Options": "DENY",
                "Referrer-Policy": "strict-origin-when-cross-origin",
                "Permissions-Policy": "camera=(), microphone=(), geolocation=()",
                "Content-Type": "application/json",
              },
            }
          )
          .catch((error) => {
            console.error("Error saving download history:", error);
          });
      },
      onError: (error) => {
        setLoading(false);
        alert(error.message);
      },
    });

  };


  // const handleCSVButtonClick = () => {
  //   downloadCSV(serverresponse);
  // };

  // const handleSimpleCSVButtonClick = async () => {
  //   await downloadSimpleExcel(serverresponse);
  // };


  // Replace handleCSVButtonClick
const handleCSVButtonClick = () => {
  downloadReportPdf({
    apiSelect,
    reportfromDateTimeFormatted,
    reporttoDateTimeFormatted,
    selectedPlatforms,
    selectedSections,
    selectedLanguages,
    selectedSentiment,
    selectedIntensity,
    selectedContent,
    selectedKeyword,
    fileType: "csv",
    onStart: () => setLoading(true),
    onSuccess: () => setLoading(false),
    onError: (error) => {
      setLoading(false);
      alert(error.message);
    },
  });
};

// Replace handleSimpleCSVButtonClick
const handleSimpleCSVButtonClick = () => {
  downloadReportPdf({
    apiSelect,
    reportfromDateTimeFormatted,
    reporttoDateTimeFormatted,
    selectedPlatforms,
    selectedSections,
    selectedLanguages,
    selectedSentiment,
    selectedIntensity,
    selectedContent,
    selectedKeyword,
    fileType: "excel",
    onStart: () => setLoading(true),
    onSuccess: () => setLoading(false),
    onError: (error) => {
      setLoading(false);
      alert(error.message);
    },
  });
};


  useEffect(() => {
    sendDataToServer();
    // fetchKeywords();
  }, [clearParams]);

  //



  // const actions = [
  //   {
  //     id: "filter",
  //     icon: <FilterListIcon sx={{ fontSize: 22 }} />,
  //     name: (
  //       <h4
  //         style={{
  //           color: "inherit",
  //           fontFamily:
  //             "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  //           margin: 0,
  //           fontWeight: 500,
  //           fontSize: "0.875rem",
  //           transition: "color 0.3s ease",
  //         }}
  //       >
  //         Filter
  //       </h4>
  //     ),
  //     onClick: handleFilterButtonClick,
  //   },


  //   {
  //     id: "printPdf",
  //     icon: <PictureAsPdfIcon sx={{ fontSize: 22 }} />,
  //     name: (
  //       <h4
  //         style={{
  //           color: "inherit",
  //           fontFamily:
  //             "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  //           margin: 0,
  //           fontWeight: 500,
  //           fontSize: "0.875rem",
  //           transition: "color 0.3s ease",
  //         }}
  //       >
  //         Print PDF
  //       </h4>
  //     ),
  //     onClick: handlePrintButtonClick,
  //   },



  //   ...(apiSelect.value === "api/filter"
  //     ? [

  //       {
  //         id: "printCsv",
  //         icon: <PrintIcon sx={{ fontSize: 22 }} />,
  //         name: (
  //           <h4
  //             style={{
  //               color: "inherit",
  //               fontFamily:
  //                 "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  //               margin: 0,
  //               fontWeight: 500,
  //               fontSize: "0.875rem",
  //               transition: "color 0.3s ease",
  //             }}
  //           >
  //             Download CSV
  //           </h4>
  //         ),
  //         onClick: handleCSVButtonClick,
  //       },



  //       {
  //         id: "printSimpleCsv",
  //         icon: <BackupTableIcon sx={{ fontSize: 22 }} />,
  //         name: (
  //           <h4
  //             style={{
  //               color: "inherit",
  //               fontFamily:
  //                 "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  //               margin: 0,
  //               fontWeight: 500,
  //               fontSize: "0.875rem",
  //               transition: "color 0.3s ease",
  //             }}
  //           >
  //             Download Excel
  //           </h4>
  //         ),
  //         onClick: handleSimpleCSVButtonClick,
  //       },



  //     ]
  //     : []),






  // ];




  const actions = [
    {
      id: "filter",
      icon: <FilterListIcon sx={{ fontSize: 22 }} />,
      name: <h4 style={{ color: "inherit", fontFamily: "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", margin: 0, fontWeight: 500, fontSize: "0.875rem", transition: "color 0.3s ease" }}>Filter</h4>,
      onClick: handleFilterButtonClick,
    },
    {
      id: "printPdf",
      icon: <PictureAsPdfIcon sx={{ fontSize: 22 }} />,
      name: <h4 style={{ color: "inherit", fontFamily: "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", margin: 0, fontWeight: 500, fontSize: "0.875rem", transition: "color 0.3s ease" }}>Print PDF</h4>,
      onClick: handlePrintButtonClick,
    },
    {
      id: "printCsv",
      icon: <PrintIcon sx={{ fontSize: 22 }} />,
      name: <h4 style={{ color: "inherit", fontFamily: "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", margin: 0, fontWeight: 500, fontSize: "0.875rem", transition: "color 0.3s ease" }}>Download CSV</h4>,
      onClick: handleCSVButtonClick,
    },
    {
      id: "printSimpleCsv",
      icon: <BackupTableIcon sx={{ fontSize: 22 }} />,
      name: <h4 style={{ color: "inherit", fontFamily: "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", margin: 0, fontWeight: 500, fontSize: "0.875rem", transition: "color 0.3s ease" }}>Download Excel</h4>,
      onClick: handleSimpleCSVButtonClick,
    },
  ];





  const list = (anchor) => (

    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 350,
        height: "100%",
        padding: "20px",
        paddingTop: "10px",
        backgroundColor: "#fff",
        textAlign: "center",
      }}
      role="presentation"
    >
      <span
        style={{
          // marginTop: "-10px",
          color: "#088395",
          fontFamily: "'Host Grotesk', sans-serif",
          fontSize: "20px",
          fontWeight: "600",
        }}
      >
        Filter Menu
      </span>

      <div className="Filters">
        <Select
          value={apiSelect}
          onChange={handleApiData}
          options={apidata}
          closeMenuOnSelect={true}
          className="my-multiselect"
          placeholder="Data Set"
          components={ApiData}
          menuPortalTarget={document.body}
          styles={{
            control: (provided, state) => ({
              ...provided,
              borderColor: "red", // Set border color to red
              "&:hover": {
                borderColor: "red", // Set border color to red on hover
              },
              boxShadow: state.isFocused ? "0 0 0 1px red" : provided.boxShadow, // Optional: set red outline when focused
            }),
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // Ensure the portal menu appears above other elements
            }),
          }}
        />
        {/* {apiSelect.value === "api/filter" ? ( */}
        <>
          <Select
            value={selectedKeyword}
            onChange={handleKeywordChange}
            options={keywordOptions} // Use keywordOptions here
            isMulti
            closeMenuOnSelect={true}
            className="my-multiselect"
            placeholder="Select Keyword"
            // maxSelectedLabels={1}
            components={Platforms}
            menuPortalTarget={document.body}
            isDisabled={apiSelect.value !== "api/filter"} // Disable conditionally
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Custom styles for the portal menu
            }}
          />

          <Select
            value={selectedPlatforms}
            onChange={handlePlatformChange}
            options={filteredPlatforms}
            isMulti
            closeMenuOnSelect={true}
            className="my-multiselect"
            placeholder="Select Platforms"
            maxSelectedLabels={3}
            components={Platforms}
            menuPortalTarget={document.body}
            isDisabled={
              apiSelect.value !== "api/socialSentiments" &&
              apiSelect.value !== "api/filter"
            } // Disable conditionally
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Custom styles for the portal menu
            }}
          />

          <Select
            value={selectedSections}
            onChange={handleSectionChange}
            options={sections}
            isMulti
            className="my-multiselect"
            placeholder="Select Section"
            maxSelectedLabels={3}
            components={Sections}
            menuPortalTarget={document.body} // Render menu in a portal
            isDisabled={apiSelect.value !== "api/filter"} // Disable conditionally
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Custom styles for the portal menu
            }}
          />

          <Select
            value={selectedLanguages}
            onChange={handleLanguageChange}
            options={languages}
            isMulti
            className="my-multiselect"
            placeholder="Select Languages"
            maxSelectedLabels={3}
            components={Languages}
            menuPortalTarget={document.body} // Render menu in a portal
            isDisabled={apiSelect.value !== "api/filter"} // Disable conditionally
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Custom styles for the portal menu
            }}
          />

          <Select
            value={selectedSentiment}
            onChange={handleSentimentChange}
            options={sentiments}
            isMulti
            className="my-multiselect"
            placeholder="Select Sentiments"
            maxSelectedLabels={3}
            components={Sentiments}
            menuPortalTarget={document.body} // Render menu in a portal
            isDisabled={
              apiSelect.value !== "api/socialSentiments"
              // &&
              // apiSelect.value !== "api/filter"
            }
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Custom styles for the portal menu
            }}
          />

          <Select
            value={selectedIntensity}
            onChange={handleIntensity}
            options={intensity}
            isMulti
            className="my-multiselect"
            placeholder="Select Intensity"
            maxSelectedLabels={3}
            components={Intensity}
            menuPortalTarget={document.body} // Render menu in a portal
            isDisabled={apiSelect.value !== "api/filter"} // Disable conditionally
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Custom styles for the portal menu
            }}
          />

          <Select
            value={selectedContent}
            onChange={handleContent}
            options={content}
            isMulti
            className="my-multiselect"
            placeholder="Select Content Type"
            maxSelectedLabels={3}
            components={Content}
            menuPortalTarget={document.body} // Render menu in a portal
            isDisabled={apiSelect.value !== "api/filter"} // Disable conditionally
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Custom styles for the portal menu
            }}
          />
        </>
        {/* 
        <div
          style={{
            // marginTop: "5px",
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
            // marginBottom: "10px",
            flexDirection: "column",
          }}
        >
          <div
            className="date-range-items"
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
              */}
        <div
          style={{
            marginLeft: "11.5px",
            marginBottom: apiSelect.value === "api/filter" ? "" : "500px",
          }}
        >
          <ReportDateTimeRange
            onFromDateTimeChange={handleFromDateTimeChange}
            onToDateTimeChange={handleToDateTimeChange}
            reportfromDateTime={reportfromDateTime}
            setreportFromDateTime={setreportFromDateTime}
            reporttoDateTime={reporttoDateTime}
            setreportToDateTime={setreportToDateTime}
          />
        </div>
        {/* {apiSelect.value === "api/filter" ? (
          <div style={{ marginBottom: "40px" }}>
            <RangeSlider onChange={handleSliderChange} />
          </div>
        ) : (
          ""
        )} */}
        {/* <Select
            value={selectedRange}
            onChange={handleRange}
            options={range}
            className="my-multiselect"
            placeholder="Select Range"
            maxSelectedLabels={1}
            components={Range}
            menuPortalTarget={document.body} // Render menu in a portal
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Custom styles for the portal menu
            }}
          /> */}
        {/* <div style={{ marginTop: "-25px", marginRight: "12px" }}> */}
        {/* </div> */}
        {/* <button onClick={generatePDF}>Download Report</button> */}
        {/* <OffcanvasMenu /> */}
        {/* DateTimeRangePicker component */}
        <div
          className="filter-buttons"
          style={{
            // marginLeft: "11.5px",
            marginTop: apiSelect.value === "api/filter" ? "" : "-500px",
          }}
        >
          <button
            className="apply-button"
            type="submit"
            onClick={handleApply}
            style={{
              width: "64px",
              padding: "10px",
              background: "linear-gradient(90deg, #28a745, #218838)",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "bold",
              transition: "background-color 0.3s ease",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
            onMouseOver={(e) =>
            (e.target.style.background =
              "linear-gradient(90deg, #218838, #1e7e34)")
            }
            onMouseOut={(e) =>
            (e.target.style.background =
              "linear-gradient(90deg, #28a745, #218838)")
            }
          >
            Apply
          </button>

          <button
            className="clear-button"
            variant="secondary"
            onClick={handleClear}
            style={{
              width: "64px",
              padding: "10px",
              background: "linear-gradient(90deg, #dc3545, #c82333)",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "bold",
              transition: "background-color 0.3s ease",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
            onMouseOver={(e) =>
            (e.target.style.background =
              "linear-gradient(90deg, #c82333, #bd2130)")
            }
            onMouseOut={(e) =>
            (e.target.style.background =
              "linear-gradient(90deg, #dc3545, #c82333)")
            }
          >
            Clear
          </button>
        </div>
      </div>



    </Box>

  );

  return (
    <div>
      {/* SpeedDial Component */}
      {/* <Box sx={{ height: 320, transform: "translateZ(0px)", flexGrow: 1 }}> */}
      <SpeedDial
        ariaLabel="SpeedDial with Filter and Print"
        sx={{
          position: "absolute",
          bottom: 40,
          right: 16,
          "& .MuiFab-primary": {
            backgroundColor: "#088395",
            color: "#ffffff",
            width: 64,
            height: 64,
            boxShadow:
              "0 8px 24px rgba(8, 131, 149, 0.4), 0 4px 12px rgba(0, 0, 0, 0.15)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              backgroundColor: "#0a9fb2",
              transform: "scale(1.05)",
              boxShadow:
                "0 12px 32px rgba(8, 131, 149, 0.5), 0 6px 16px rgba(0, 0, 0, 0.2)",
            },
          },
          "& .MuiSpeedDialAction-fab": {
            backgroundColor: "#088395",
            color: "#ffffff",
            boxShadow:
              "0px 6px 20px rgba(8, 131, 149, 0.35), 0px 2px 8px rgba(0, 0, 0, 0.15)",
            border: "none",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            width: 48,
            height: 48,
            "&:hover": {
              backgroundColor: "#ffffff",
              color: "#088395",
              transform: "scale(1.15)",
              boxShadow:
                "0px 8px 28px rgba(255, 255, 255, 0.9), 0px 4px 12px rgba(8, 131, 149, 0.3)",
              border: "2px solid #088395",
            },
          },
          "& .MuiSpeedDialAction-staticTooltipLabel": {
            backgroundColor: "#088395",
            color: "#ffffff",
            fontFamily:
              "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            fontSize: "0.875rem",
            fontWeight: 500,
            padding: "12px 18px",
            borderRadius: "25px",
            boxShadow:
              "0 6px 20px rgba(8, 131, 149, 0.4), 0 3px 10px rgba(0, 0, 0, 0.2)",
            border: "2px solid transparent",
            whiteSpace: "nowrap",
            minWidth: "fit-content",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              backgroundColor: "#ffffff",
              color: "#088395",
              transform: "translateX(-4px) scale(1.05)",
              boxShadow:
                "0 10px 30px rgba(255, 255, 255, 0.95), 0 5px 15px rgba(8, 131, 149, 0.4)",
              border: "2px solid #088395",
            },
            "& h4": {
              margin: 0,
              fontFamily:
                "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
              fontWeight: 500,
              fontSize: "0.875rem",
              color: "inherit",
              transition: "color 0.3s ease",
            },
          },
          // Backdrop overlay when open
          "& + .MuiBackdrop-root": {
            backgroundColor: "rgba(8, 131, 149, 0.12)",
            backdropFilter: "blur(4px)",
          },
        }}
        icon={<SpeedDialIcon />}
        open={open}
        onClick={handleToggle}
        FabProps={{
          sx: {
            "&:active": {
              boxShadow: "0 4px 12px rgba(8, 131, 149, 0.3)",
            },
          },
        }}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.id}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={action.onClick}
            FabProps={{
              sx: {
                "&:active": {
                  transform: "scale(1.05)",
                },
              },
            }}
          />
        ))}
      </SpeedDial>
      <SwipeableDrawer
        anchor={anchor}
        open={state[anchor]}
        onClose={() => toggleDrawer(false)} // Close drawer when the backdrop is clicked
        onOpen={() => toggleDrawer(true)} // Optional: can use this if you need special logic when it opens
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#ffffff", // Set white background
            borderRadius: "25px 0 0 25px", // Round only the top-left and bottom-left corners
            height: "100vh", // Ensure it fills the height if needed
          },
          borderRadius: "25px 0 0 25px", // Same for the parent container, if needed
        }}
      >
        {list()} {/* Content inside the drawer */}
      </SwipeableDrawer>
    </div>
  );
}
